import { createSelector, MemoizedSelector } from '@ngrx/store';
import {
  anyPass,
  compose,
  defaultTo,
  find,
  isEmpty,
  isNil,
  prop,
  propOr,
} from 'ramda';

import { authProfile } from '../auth/auth.selectors';
import { memberProfile, trueBlueNumber } from '../profile/profile.selectors';
import { AppState } from '../shared/types/app-state.type';
import { TrueBlueProfile } from '../trueblue/types';

type Loyalty = TrueBlueProfile['loyalty'][0];

export const passIfNonEmptyAndNotNil = val => {
  if (anyPass([isNil, isEmpty])(val)) {
    return null;
  } else {
    return val;
  }
};

export const userPoints: MemoizedSelector<AppState, string | null> =
  createSelector(
    authProfile,
    memberProfile,
    trueBlueNumber,
    compose(
      passIfNonEmptyAndNotNil,
      (authProfileV, memberProfileV, tbMemberNumber) => {
        const pointsInMemberProfile = compose(
          defaultTo(null),
          prop('amount') as any,
          find(({ membershipId }: Loyalty) => membershipId === tbMemberNumber),
          propOr([], 'loyalty'),
        )(memberProfileV);

        /*
        Profile service might be unresponsive/token might have expired (see DOT-4089)
      */
        if (!pointsInMemberProfile) {
          if (authProfileV && authProfileV.points) {
            return authProfileV.points.toString();
          } else {
            return null;
          }
        } else {
          return pointsInMemberProfile;
        }
      },
    ),
  );
